window.addEventListener("load", (event) => {
  if (!document.querySelector(".collection-exist")) {
    if(document.querySelector("section#shopify-section-template--16382702911661__38dc8f55-0b86-424e-9dc1-e5b2002bda45")) {
      document.querySelector("section#shopify-section-template--16382702911661__38dc8f55-0b86-424e-9dc1-e5b2002bda45").remove();
    }
  }
});

function createCustomSelect(selectElementId, ulElementId) {
    let selectElement = document.getElementById(selectElementId);
    let ulElement = document.querySelector(ulElementId);

    if(selectElement) {
      selectElement.style.display = 'none';

      // Create a custom div to mimic the select behavior
      let customSelect = document.createElement('div');
      customSelect.classList.add('custom-select');
      customSelect.innerText = selectElement.value; // Show the current selection
  
      function closeDropdown() {
        ulElement.classList.remove('active');
      }
  
      customSelect.addEventListener('click', function () {
        ulElement.classList.toggle('active');
      });
  
      let options = selectElement.querySelectorAll('option');
      for (let i = 0; i < options.length; i++) {
        let option = options[i];
        let value = option.value;
        let name = option.textContent.trim();
  
        let listItem = document.createElement('li');
        listItem.textContent = name;
        listItem.setAttribute('data-value', value);
  
        listItem.addEventListener('click', function () {
          let selectedValue = this.getAttribute('data-value');
          let selectedName = this.textContent;
  
          customSelect.innerText = selectedName;
  
          selectElement.value = selectedValue;
  
          let changeEvent = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(changeEvent);
  
          // Close the dropdown after selection
          closeDropdown();
        });
  
        // Append the list item to the ul element
        ulElement.appendChild(listItem);
      }
  
      ulElement.parentNode.insertBefore(customSelect, ulElement);
  
      document.addEventListener('click', function (event) {
        let target = event.target;
        if (!ulElement.contains(target) && !customSelect.contains(target)) {
          closeDropdown();
        }
      });
    }
  }

// convert select in current product page template
createCustomSelect('Option-template--16103119913133__main-0', '.sort-template--16103119913133__main-0');
createCustomSelect('Option-template--16103119913133__main-1', '.sort-template--16103119913133__main-1');



document.querySelectorAll(".upsell-items [type=checkbox]").forEach((c, i) => {
    c.addEventListener('click', (e) => {
      if (e.target.checked) {
        document.querySelectorAll(".upsell-details")[i].style.pointerEvents = "unset";
        document.querySelectorAll(".upsell-details")[i].style.opacity = 1;
      } else {
        document.querySelectorAll(".upsell-details")[i].style.pointerEvents = "";
        document.querySelectorAll(".upsell-details")[i].style.opacity = "";
      }
    });
  });

  // add some magic here to bypass single product add
  // document.querySelector(`[data-type="add-to-cart-form"] .product-variant-id`).name = "id[]";
  document.addEventListener("DOMContentLoaded", function () {
    const checkboxElements = document.querySelectorAll(".transparent-checkbox");
    const selectElements = document.querySelectorAll(".upsell-selection");

    checkboxElements.forEach(function (checkbox, index) {
      checkbox.addEventListener("change", function () {
        if (checkbox.checked) {
          const selectedValue = selectElements[index].value;
          console.log("Selected value for checkbox", index, ":", selectedValue);
          document.querySelector(`[data-type="add-to-cart-form"]`).innerHTML += `<input hidden name="id[]" data-id="e-${index}" value="${selectedValue}" class="product-variant-id">`;
        } else {
          console.log("Checkbox", index, "is unchecked.");
          document.querySelectorAll(".select-radio")[index].style.display = "";
          const addedInput = document.querySelector(`[data-id="e-${index}"]`);
          if (addedInput) {
            addedInput.remove();
          }
        }
      });
    });

    // selectElements.forEach((element, index) => {
    //   element.addEventListener("change", () => {
    //     console.log("val->", element.value);
    //     document.querySelector(`[data-id="e-${index}"]`).remove();
    //     document.querySelector(`[data-type="add-to-cart-form"]`).innerHTML += `<input hidden name="id[]" data-id="e-${index}" value="${element.value}" class="product-variant-id">`;
    //   });
    // })
  });


  // Function to convert select elements to custom-styled radio buttons
  function convertSelectToRadios(selectElement, index) {
    const options = selectElement.querySelectorAll("option");
    const upsellVal = document.querySelectorAll(".upsell-option-val");

    // Remove the original select element
    selectElement.style.display = "none";
    const container = document.createElement("div");
    container.className = 'select-radio';
    const radioGroupName = `${selectElement.name}_${index}`;

    options.forEach((option, optionIndex) => {
      const radio = document.createElement("input");
      radio.type = "radio";
      radio.name = radioGroupName; // Use the dynamically generated radio button group name
      radio.value = option.value;
      radio.id = `option-${index}-${optionIndex}`; // Generate unique ID for each radio button

      // Set the first radio button to be checked by default
      if (optionIndex === 0) {
        radio.checked = true;
        // Update the corresponding select element's value with the default selected value
        selectElement.value = radio.value;
      }

      const label = document.createElement("label");
      label.textContent = option.textContent;
      label.setAttribute("for", `option-${index}-${optionIndex}`); // Associate label with the corresponding radio button

      container.appendChild(radio);
      container.appendChild(label);

      upsellVal[index].textContent = radio.nextSibling.textContent;

      radio.addEventListener("change", () => {
        // Update the corresponding select element's value
        selectElement.value = radio.value;
        upsellVal[index].textContent = radio.nextSibling.textContent;
        console.log(radio.nextSibling.textContent);
        document.querySelector(`[data-id="e-${index}"]`).remove();
        document.querySelector(`[data-type="add-to-cart-form"]`).innerHTML += `<input hidden name="id[]" data-id="e-${index}" value="${selectElement.value}" class="product-variant-id">`;
      });
    });

    // Add the container with custom-styled radio buttons after the original select element
    selectElement.parentNode.insertBefore(container, selectElement.nextSibling);
  }


  // Convert all select elements to custom-styled radio buttons
  const selectElements = document.querySelectorAll(".upsell-selection");
  selectElements.forEach((element, index) => {
    convertSelectToRadios(element, index);
  });

  document.querySelectorAll(".upsell-option-val").forEach((e, i) => {
    const list = document.querySelectorAll(".select-radio")[i];
    e.addEventListener("click", () => {
      if (list.style.display == "") {
        list.style.display = "block";
      } else {
        list.style.display = "";
      }
    })
  });



const inlineMenus = document.querySelectorAll('.header__inline-menu details');
if(inlineMenus) {
  inlineMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      menu.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', () => {
      menu.removeAttribute('open');
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelectorAll(".select-radio")) {
    document.querySelectorAll(".select-radio").forEach((e, i) => {
        e.querySelectorAll("label").forEach((c) => {
            c.addEventListener("click", () => {
                document.querySelectorAll(".select-radio")[i].style.display = "";
            });
        });
    });
  }
});

window.onload = function() {
  // Get references to the checkboxes
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');

  // Loop through each checkbox and set its checked property to false
  checkboxes.forEach(function(checkbox) {
    checkbox.checked = false;
  });

  const images = document.querySelectorAll(".product-image-custom");
  if(images) {
    images.forEach(image => {
        image.onload = function() {
            image.style.display = "block";
        };
    });
  }
};

